export default {
      id: "user-check-usage",
      viewBox: "0 0 640 512",
      url: __webpack_public_path__ + "img/icons.6f915410.svg#user-check",
      toString: function () {
        return this.url;
      }
    }